'use strict';

function ctrl() {
    // $stateProvider
    //     .state('changelog.main', {
    //         url: '/changelog',
    //         template: require('../views/main.html'),
    //         controller: 'changelogMainCtrl',
    //         controllerAs: 'changelog'
    //     })
}

ctrl.$inject = ['$stateProvider'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/changelog/routes/changelog.js
 **/